module.exports = __webpack_public_path__ + "media/images/logo-full-cc3a3a1800ad5e882c2538399bb661fe.png";